import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#9ca3af","font-size":"14px"}
}
const _hoisted_3 = {
  key: 1,
  class: "admin-table"
}
const _hoisted_4 = { class: "user-avatar" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "user-avatar-initials"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "data-title" }, "Usuários", -1)),
    (!$setup.detail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Avatar"),
              _createElementVNode("th", null, "Nome"),
              _createElementVNode("th", null, "Usuário"),
              _createElementVNode("th", null, "Cargo")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detail.users, (u) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: u.username
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_4, [
                    (u.avatar && (u.avatar.startsWith('data:') || u.avatar.startsWith('/uploads/')))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.resolveAvatar(u.avatar),
                          alt: "avatar"
                        }, null, 8, _hoisted_5))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.initials(u.name)), 1))
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(u.name), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("code", null, _toDisplayString(u.username), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["role-badge", $setup.roleClass(u.role)])
                  }, _toDisplayString($setup.roleLabel(u.role)), 3)
                ])
              ]))
            }), 128))
          ])
        ]))
  ]))
}